import React from 'react';

export default function Footer() {
  return (
    <footer>
      <div className="footer-sigil">✦</div>
      <a className="brand footer-brand" href="#top">E.A. <span>KROSS</span></a>
      <p>Stories of magic, monsters, and the shadows between.</p>
      <div className="footer-links">
        <a href="#books">Books</a>
        <a href="#characters">Characters</a>
        <a href="#author">Author</a>
      </div>
      <small>© {new Date().getFullYear()} E.A. Kross. All rights reserved.</small>
    </footer>
  );
}
